import "./src/styles/global.scss"

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== `undefined`) {
    if (!location.hash) {
      window.scrollTo(0, 0)
    }
  }
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  window.scrollTo([0, 0])

  return false
}